<div class="mb-3">
    @if (label != null) {
        <label for="{{ id }}">{{ label }}</label>
    }
    @if (showRequired) {
        <span class="required-indicator">*</span>
    }
    <textarea [readonly]="isReadOnly" [id]="id" [attr.rows]="rows" class="form-control" [formControl]="control" maxlength="{{ maxLength }}" #inputControl></textarea>
    <p class="text-end">
        <small class="text-muted form-text">
            <code>{{ inputControl.value.length }}</code> of {{ maxLength }} characters used
        </small>
    </p>
    @if (control.invalid) {
        <span class="help-block">
            <span class="required-indicator">
                {{ getErrorMessage() }}
            </span>
        </span>
    }
</div>
